import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/const"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function ViewCashSession (){
  const {user} = useUser()
  let view = contentLayout[modules.CashSessionList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.CashSessionList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.CashSessionList}></Index>
 )
}

export default ViewCashSession